import { ReactElement } from 'react';

import { Dialog, KnownDialogs, useDialog } from 'modules/dialogs';

import { Navigation } from '../../../layout/components/Navigation';

export function NavigationDialog(): ReactElement {
  const { isOpened, onClose } = useDialog(KnownDialogs.navigation);

  return (
    <Dialog open={isOpened} onClose={onClose}>
      <Navigation />
    </Dialog>
  );
}
